<app-layout>
    <!-- components title start -->
    <div class="components-title">
        <h2>{{ $t('BitZipp Earning') }}</h2>
    </div>
    <!-- components title end -->

    <!-- tabs components start -->
    <div class="tabs-components tabs">

        <!-- tabs left start -->
        <div class="tabs-left">
            <div class="tabs-nav">
                <div @click="setSort('all')" class="tabs-nav__item" :class="{'tabs-nav__active': sort == 'all'}">
                    <h4>{{ $t('Available coins') }}</h4>
                </div>
                <div @click="setSort('my')" class="tabs-nav__item" :class="{'tabs-nav__active': sort == 'my'}">
                    <h4>{{ $t('My Earnings') }}</h4>
                </div>
            </div>
        </div>
        <!-- tabs left end -->
    </div>
    <!-- tabs components end -->
    <span class="text-gray-500">{{ $t('* Earning rewards are calculated every day at 00:00 UTC')}}</span>
    <!-- table components start -->
    <div v-if="sort == 'all'" class="table-components">

        <!-- tables start -->
        <table class="tables mob-table-stakings-available">

            <!-- thead start -->
            <thead class="table-sort">
            <tr>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Coin') }}</span>
                    </div>
                </th>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Min Amount') }}</span>
                    </div>
                </th>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Max Amount') }}</span>
                    </div>
                </th>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Status') }}</span>
                    </div>
                </th>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Actions') }}</span>
                    </div>
                </th>
            </tr>
            </thead>
            <!-- thead end -->
            <!-- tbody start -->
            <tbody class="table-list">
            <tr @click="setStaking(staking)" v-for="staking in stakings.data" :key="staking.id"  class="table-list__cursor">
                <td>
                    <div class="table-list__subtitle">{{ $t('Coin') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__image">
                            <img :src="staking.currency_logo" />
                        </div>
                        <div class="table-list__title">
                            <span class="table-list__title-big">{{ staking.currency_symbol }}</span>
                            <span class="table-list__title-small">{{ staking.currency }}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('Min amount') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__title title-icon">
                            <div class="title-icon__name">{{ staking.min_amount }}</div>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('Max amount') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__title title-icon">
                            <div class="title-icon__name">{{ staking.max_amount }}</div>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('Status') }}</div>
                    <div class="table-list__value">
                        <div class="components-label" :class="{'label-green': staking.status == 'active', 'label-orange': staking.status == 'sold'}">
                            <template v-if="staking.status == 'active'">{{ 'Active' }}</template>
                            <template v-if="staking.status == 'sold'">{{ 'Sold Out' }}</template>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('Actions') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__link">
                            <a href="#!">{{ $t('Read more') }}</a>
                            <a v-if="staking.status == 'active'" href="#!">{{ $t('Earn now') }}</a>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
            <!-- tbody end -->

            <!-- tfood start -->
            <tfoot class="table-result">
            <tr>
                <td colspan="100">
                    <div v-if="stakings.data && stakings.data.length == 0" class="table-result__notfound">
                        <span class="table-result__notfound-icon">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path class="table-result__notfound-color" d="M21 13V11C21 7.73081 21 6.09621 20.3272 4.86413C19.8219 3.93873 19.0613 3.17807 18.1359 2.67277C16.9038 2 15.2692 2 12 2V2C8.73081 2 7.09621 2 5.86413 2.67277C4.93873 3.17807 4.17807 3.93873 3.67277 4.86413C3 6.09621 3 7.73081 3 11V12.5C3 16.2433 3 18.1149 3.87311 19.4735C4.29935 20.1368 4.86322 20.7006 5.52648 21.1269C6.88505 22 8.7567 22 12.5 22V22H13" stroke="#222628"/>
                                <line class="table-result__notfound-color" x1="15.5" y1="13.5" x2="7.5" y2="13.5"/>
                                <line class="table-result__notfound-color" x1="15.5" y1="10.5" x2="7.5" y2="10.5"/>
                                <line class="table-result__notfound-color" x1="11.5" y1="7.5" x2="7.5" y2="7.5"/>
                                <rect class="table-result__notfound-color color-yellow" x="14.8335" y="14.8335" width="7.08333" height="7.08333" rx="3.54167"/>
                                <line class="table-result__notfound-color color-yellow" x1="21.1803" y1="21.3066" x2="22.5565" y2="22.6829"/>
                            </svg>
                        </span>
                        <span class="table-result__notfound-text">{{ $t('No coins for staking found.') }}</span>
                    </div>
                </td>
            </tr>
            </tfoot>
            <!-- tfood end -->

        </table>
        <!-- tables end -->

    </div>
    <!-- table components end -->

    <div v-if="sort == 'my'" class="table-components">

        <!-- tables start -->
        <table class="tables mob-table-stakings-my">

            <!-- thead start -->
            <thead class="table-sort">
            <tr>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Coin') }}</span>
                    </div>
                </th>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Staked') }}</span>
                    </div>
                </th>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('APY') }}</span>
                    </div>
                </th>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Period') }}</span>
                    </div>
                </th>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Your reward') }}</span>
                    </div>
                </th>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Status') }}</span>
                    </div>
                </th>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Redemption Date') }}</span>
                    </div>
                </th>
                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Actions') }}</span>
                    </div>
                </th>
            </tr>
            </thead>
            <!-- thead end -->

            <!-- tbody start -->
            <tbody class="table-list">
            <tr v-for="staking in stakings.data" :key="staking.id">
                <td>
                    <div class="table-list__subtitle">{{ $t('Coin') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__image">
                            <img :src="staking.currency_logo" />
                        </div>
                        <div class="table-list__title">
                            <span class="table-list__title-big">{{ staking.currency_symbol }}</span>
                            <span class="table-list__title-small">{{ staking.currency }}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('Staked') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__title title-icon">
                            <div class="title-icon__name">{{ staking.amount }} {{ staking.currency_symbol }}</div>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('APY') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__title title-icon">
                            <div class="title-icon__name">{{ staking.apy }}</div>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('Period') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__title title-icon">
                            <div class="title-icon__name">{{ staking.days }} {{ staking.days == 1 ? $t('day') : $t('days') }}</div>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('Your reward') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__title title-icon">
                            <div class="title-icon__name">
                                {{ staking.status == 'redeemed' ? 0 : staking.reward }}
                                {{ staking.currency_symbol }}
                            </div>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('Period') }}</div>
                    <div class="table-list__value">
                        <div class="components-label" :class="{'label-green': staking.status == 'active' || staking.status == 'completed', 'label-gray': staking.status == 'redeemed'}">
                            <template v-if="staking.status == 'active'">{{ 'Active' }}</template>
                            <template v-if="staking.status == 'redeemed'">{{ 'Redeemed' }}</template>
                            <template v-if="staking.status == 'completed'">{{ 'Completed' }}</template>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('Redemption Date') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__title title-icon">
                            <div class="title-icon__name">
                                {{ staking.redemption_date }}
                            </div>
                        </div>
                    </div>
                </td>

                <td>
                    <div class="table-list__subtitle">{{ $t('Actions') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__link">
                            <a @click.prevent="redeem(staking.id)" v-if="staking.status == 'active'" href="#!">{{ $t('Redeem in advance') }}</a>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
            <!-- tbody end -->

            <!-- tfood start -->
            <tfoot class="table-result">
            <tr>
                <td colspan="100">
                    <div v-if="stakings.data && stakings.data.length == 0" class="table-result__notfound">
                        <span class="table-result__notfound-icon">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path class="table-result__notfound-color" d="M21 13V11C21 7.73081 21 6.09621 20.3272 4.86413C19.8219 3.93873 19.0613 3.17807 18.1359 2.67277C16.9038 2 15.2692 2 12 2V2C8.73081 2 7.09621 2 5.86413 2.67277C4.93873 3.17807 4.17807 3.93873 3.67277 4.86413C3 6.09621 3 7.73081 3 11V12.5C3 16.2433 3 18.1149 3.87311 19.4735C4.29935 20.1368 4.86322 20.7006 5.52648 21.1269C6.88505 22 8.7567 22 12.5 22V22H13" stroke="#222628"/>
                                <line class="table-result__notfound-color" x1="15.5" y1="13.5" x2="7.5" y2="13.5"/>
                                <line class="table-result__notfound-color" x1="15.5" y1="10.5" x2="7.5" y2="10.5"/>
                                <line class="table-result__notfound-color" x1="11.5" y1="7.5" x2="7.5" y2="7.5"/>
                                <rect class="table-result__notfound-color color-yellow" x="14.8335" y="14.8335" width="7.08333" height="7.08333" rx="3.54167"/>
                                <line class="table-result__notfound-color color-yellow" x1="21.1803" y1="21.3066" x2="22.5565" y2="22.6829"/>
                            </svg>
                        </span>
                        <span class="table-result__notfound-text">{{ $t('No active staked coins found.') }}</span>
                    </div>
                </td>
            </tr>
            </tfoot>
            <!-- tfood end -->

        </table>
        <!-- tables end -->

    </div>

<div class="faq-block-stake">

</div>
</app-layout>
